import { useCallback } from 'react';
import { useLoginContext } from '../reducer/useLogin';
import { requestOtp } from '../../rest-api/request';
import { parseAuthError } from '../../rest-api/utils';

export const useRequestOTP = () => {
  const [state, dispatch] = useLoginContext();
  const isLoading = state.loading;
  return useCallback(
    async (phoneNumber: string) => {
      if (isLoading) {
        return;
      }
      dispatch('LOADING');
      try {
        await requestOtp(phoneNumber);
        dispatch({ type: 'VERIFYING_OTP', phoneNumber });
      } catch (error) {
        const errorResponse = parseAuthError(error);
        const reason =
          errorResponse?.error_code === 'LOCAL_USER_NOT_FOUND'
            ? 'local-user-not-found'
            : 'generic-error';
        dispatch({ type: 'REQUESTING_OTP', phoneNumber, error: reason });
      }
    },
    [isLoading, dispatch],
  );
};
